// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent--31yMY"};